import React from "react";
import styled from "styled-components";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import { Container } from "react-bootstrap";

const Kits = () => (
  <Wrapper>
    <Container>
      <UnderlinedHeader text={"Zestawy zawieszeń 4x4"} bolder />
      <p>
        Zawieszenia TrakRyder przeznaczone do samochodów z napędem na cztery
        koła są efektem wielu lat doświadczenia oraz rozwoju technologicznego.
        Zapewniają nowy poziom prowadzenia i komfortu. Zawieszenie TrakRyder
        marki Pedders posiada w gamie setki wysokiej jakości komponentów
        zaprojektowanych i skonstruowanych tak, aby poprawić jakość prowadzenia
        w samochodach 4×4. Sukcesy jakie odnoszą systemy zawieszeń Pedders 4×4
        nie są uwarunkowane tylko i wyłącznie produktem. TrakRyder to cały
        system „szyty na miarę”, a jego efektywność wynika z faktu, że całość
        może być spersonalizowana dla potrzeb klienta i dopasowana do każdego
        pojazdu 4WD.
      </p>
      <p>
        Systemem TrakRyder daje radość z prowadzenia pojazdu 4x4. Jest
        wzmocniony, przeznaczonym do bardziej wymagających dróg, przy czym
        zachowuje jakość prowadzenia, charakterystyczną dla standardowych aut. Z
        systemem TrakRyder możesz korzystać ze wszystkich trudnych szlaków, na
        jakie pozwala pojazd 4×4 i jednocześnie korzystać z łatwości
        prowadzenia, jak zwykłego auta rodzinnego. Dla właścicieli nowych
        samochodów system TrakRyder oznacza koniec koniecznego kompromisu
        pomiędzy napędem 4×4, a rezygnacją z komfortu jazdy.
      </p>
      <Bolder>
        System TrakRyder oferuje komfort na drodze wraz z wyśmienitą kontrolą na
        bezdrożach
      </Bolder>
      <p>
        Gdy to w codziennej drodze do pracy, czy w trakcie ciągnięcia przyczepy,
        czy ciężkiego ładunku i przewozu towarów, możesz być pewien, że
        zawieszenie Pedders TrakRyder pomoże dostosować układ zawieszenia
        pojazdu do Twoich potrzeb.
      </p>
      <Bolder>Gama produktów Pedders TrakRyder:</Bolder>
      <ul>
        <li>Amortyzatory</li>
        <li>Sprężyny</li>
        <li>Resory piórowe</li>
        <li>Tuleje gumowe</li>
        <li>Tuleje poliuretanowe</li>
        <li>Amortyzatory skrętu</li>
        <li>Wieszaki resorów</li>
        <li>Poduszki powietrzne</li>
        <li>Drążki skrętne</li>
        <li>Części do układu kierowniczego i podwozia</li>
        <li>Górne mocowania kolumn</li>
        <li>Jarzma resorów – U-bolt</li>
        <li>Elementy do ustawiania geometrii kół</li>
        <li>Zaawansowane części do nastawów geometrii kół pojazdów 4×4</li>
      </ul>
    </Container>
  </Wrapper>
);

export default Kits;

const Wrapper = styled.section`
  padding-top: 92px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #666666;
`;

const Bolder = styled.p`
  font-weight: 600;
  font-size: 16px;
`;
